<template>
  <div class="preHouseholdInfoManageList">
    <div class="filters">
      <el-form :inline="true" :model="form" ref="form">
        <el-form-item>
          <el-select @change="selectUnit" v-model="form.houseId" filterable>
            <el-option key :label="$t('lang.lab_selectHouse')" value=""></el-option>
            <el-option v-for="(item,index) in houses" :key="index" :value="item.id" :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select @change="selectRoom" v-model="form.unitId" filterable>
            <el-option key :label="$t('lang.lab_selectUnit')" value=""></el-option>
            <el-option v-for="(item,index) in units" :key="index" :value="item.id" :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.roomId" filterable>
            <el-option key :label="$t('lang.lab_selectRoom')" value=""></el-option>
            <el-option v-for="(item,index) in rooms" :key="index" :value="item.id" :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input :placeholder="$t('lang.lab_preHouseholdNameOrPhone')" v-model="form.key"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input :placeholder="$t('lang.lab_preHouseholdId')" v-model="form.id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.fjType">
            <el-option key :label="$t('lang.lab_fjType')" :value="$t('lang.lab_indexFjType')"></el-option>
            <el-option v-for="item in fjTypes" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input :placeholder="$t('lang.lab_fjName')" v-model="form.fjName"></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
        <el-button type="success" @click="download">{{$t('lang.btn_downloadTemplate')}}</el-button>
        <el-upload class="upload-demo" ref="uploading" action :on-remove="handleRemove" :on-change="handleSuccess"
          :on-exceed="outlimit" :on-error="uploadErr1" :limit="1" accept=".xlsx,.xls" :file-list="fileList"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">{{$t('lang.btn_selectExcel')}}</el-button>
          <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">
            {{$t('lang.btn_importExcel')}}</el-button>
        </el-upload>
      </el-form>
    </div>
    <el-card>
      <el-button type="danger" slot="header" v-if="showbatchDelBtn" @click="batchDel('')" :disabled="selectArr.length<2">
        批量删除</el-button>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_addPreHouseholdInfo')}}</el-button>
      <el-button type="primary" slot="header" @click="excelDownloadClick">{{$t('lang.btn_excelDl')}}</el-button>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <el-table-column type="selection" width="55" v-if="showbatchDelBtn"></el-table-column>
        <el-table-column prop="id" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <el-table-column prop="name" :label="$t('lang.lab_preHouseholdName')">
        </el-table-column>
        <el-table-column prop="houseName" :label="$t('lang.lab_buildingnum')">
        </el-table-column>
        <el-table-column prop="unitName" :label="$t('lang.lab_unitnum')">
        </el-table-column>
        <el-table-column prop="roomName" :label="$t('lang.lab_roomnum')">
        </el-table-column>
        <el-table-column prop="mobile" :label="$t('lang.lab_preHouseholdPhone')">
        </el-table-column>
        <el-table-column prop="idNo" :label="$t('lang.lab_preHouseholdID')">
        </el-table-column>
        <el-table-column prop="buildArea" :label="$t('lang.lab_preHouseholdArea')">
        </el-table-column>
        <el-table-column prop="feeArea" :label="$t('lang.lab_feeArea')">
        </el-table-column>
        <el-table-column fixed="right" prop="opration" :label="$t('lang.lab_operation')"
          :width="editPreInfoIsUseApprove==1?require('@/config/enum').opr_width5:require('@/config/enum').opr_width6">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" v-if="showbatchDelBtn" @click="batchDel(scope.row.id)">删除</el-button>
            <el-button @click="carPlaceInfo(scope.row)">{{$t('lang.lab_addPlace')}}</el-button>
            <el-button @click="waterElectricity(scope.row,1)">{{"添加水表"}}</el-button>
            <el-button @click="waterElectricity(scope.row,2)">{{"添加电表"}}</el-button>
            <el-button @click="rentInfo(scope.row)">{{"添加租赁信息"}}</el-button>
            <el-button class="orange" v-if="editPreInfoIsUseApprove==1" @click="showEditBasicInfoDialog(scope.row)">修改基本信息</el-button>
            <el-button class="orange"  @click="tenantsInfo(scope.row)" >添加租户</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="staffName" :label="$t('lang.lab_housekeeper')" width="200"></el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <el-dialog title="修改原始业主基本信息" :visible.sync="editBasicInfoDialog" :close-on-click-modal="false" center top="130px"
      width="1000px">
      <!-- 表单验证 -->
      <el-form :model="basicInfoForm" :rules="rules" ref="basicInfoForm" :label-width="require('@/config/enum').c_ws4"
        :label-suffix="require('@/config/enum').c_colon">
        <!-- 名称 -->
        <el-form-item label="姓名" prop="name">
          <el-input v-model="basicInfoForm.name" placeholder="请输入姓名" maxlength="11"></el-input>
        </el-form-item>
        <!-- 电话 -->
        <el-form-item label="电话" prop="mobile">
          <el-input v-model="basicInfoForm.mobile" @input="keyMobile" placeholder="请输入电话号码" maxlength="11"></el-input>
        </el-form-item>
        <!-- 身份证号 -->
        <el-form-item label="身份证号" prop="idNo">
          <el-input v-model="basicInfoForm.idNo" placeholder="请输入身份证号"></el-input>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item label="备注" prop="remark">
          <el-input v-model="basicInfoForm.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
        <!-- 附件 -->
        <el-form-item label="图片上传" prop="urls99" ref="urls99" class="editor-width">
          <upload-morefile ref="uploading" :accept='accept' upTypes='1' :fileList='filesList99' :clears='clears'
            @outputFile="getFile99" @removeFile='removeFile99'></upload-morefile>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editBasicInfoDialog = false">取消</el-button>
        <el-button type="primary" @click="editBasicInfo('basicInfoForm')">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // 引入富文本title汉字
  // eslint-disable-next-line no-unused-vars
  import {
    excelDownload
  } from '../../../config/download.js'
  import uploadmoreFile from '../../../components/upload_morefile.vue'
  import {
    mapGetters
  } from 'vuex'
  /**
   *@ClassName:preHouseholdInfoManageList
   *@Description:原始住户数据管理
   *@author:宋莎
   *@Copyright:格众科技
   *@date:2020-03-12
   */
  export default {
    name: '/manage/main.roomOwner',
    data() {
      return {
        multipleSelection: [], // 多选框
        type: 1, // 1:楼 2：单元 3：房间
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        form: {
          houseId: '', // 楼号
          unitId: '', // 单元号
          roomId: '', // 房间号 
          key: '', // 关键词
          id: '', // 序号
          fjType: '0',
          fjName: '',
        },
        isImageFlag: '', // 判断是否选择文件，空为没有上传
        houses: [], //  存储根据小区请求回来的楼号
        units: [], //  存储根据楼号请求回来的单元
        rooms: [], //  存储根据单元请求回来的房间号
        tableData: [], // 列表数据
        uploadFile: '',
        fileList: [], // 上传
        fjTypes: this.$i18n.t('lang.fjTypes'), // 下拉列表
        preHouseholdInfoManageListcheckbox: require('@/config/enum').preHouseholdInfoManageListcheckbox, // 是否隐藏复选框
        selectArr: [], // 批量删除id数组
        showbatchDelBtn: false, // 批量删除按钮显示状态（true显示  false隐藏）
        rowData: '', // 修改之前业主信息
        editBasicInfoDialog: false, // 修改业主基本信息弹窗状态（true显示  false隐藏）
        basicInfoForm: {
          name: '',
          mobile: '',
          idNo: '',
          remark: '',
        },
        rules: {
          name: [{
            required: true,
            message: '请输入业主姓名',
            trigger: 'blur'
          }],
          mobile: [{
            required: true,
            message: '请输入业主电话号码',
            trigger: 'blur'
          }, {
            pattern: /1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}/,
            required: true,
            message: '请输入正确电话号码',
            trigger: 'blur'
          }],
          idNo: [{
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            required: false,
            message: '请输入正确身份证号码',
            trigger: 'blur'
          }],
        },
        clears: false,
        accept: '*.*',
        fileList99: [],
        filesList99: [],
      }
    },
    components: {
      'upload-morefile': uploadmoreFile
    },
    created() {
      setTimeout(() => {
        window.localStorage.setItem('editPreInfoForm', '')
        window.localStorage.setItem('editPreInfoSaveData', '')
      }, 200)
      this.selectHouse(this.gardenId)
      this.getData()
      this.getLastDate()
    },
    activated() {
      // this.selectHouse(this.gardenId)
      this.getData()
    },
    computed: {
      ...mapGetters(['gardenId', 'userGardenList', 'editPreInfoIsUseApprove'])
    },
    methods: {
      // 获取是否有删除权限
      getLastDate() {
        let lastDate = ''
        this.userGardenList.map(item => {
          if (item.id == this.gardenId) {
            lastDate = item.gardenDeleteValid
          }
        })
        const lastTimestamp = new Date(lastDate).getTime()
        const nowTimestamp = new Date().getTime()
        console.log('现在时间戳：' + nowTimestamp)
        console.log('最后时间戳：' + lastTimestamp)
        if (lastTimestamp > nowTimestamp) {
          console.log('有权限')
          this.showbatchDelBtn = true
        }
      },
      carPlaceInfo(row) {
        this.$router.push({
          path: '/manage/carPlaceInfo',
          query: {
            row: row
          }
        })
      },
      waterElectricity(row,type) {
        this.$router.push({
          path: '/manage/waterInfo',
          query: {
            row: row,
            type:type
          }
        })
      },
      rentInfo(row) {
        this.$router.push({
          path: '/manage/rentInfo',
          query: {
            row: row
          }
        })
      },
      tenantsInfo(row) {
        this.$router.push({
          path: '/manage/tenants',
          query: {
            row: row
          }
        })
      },
      // 上传文件的断网
      uploadErr1() {
        if (!navigator.onLine || window.navigator.onLine === false) {
          const loading = this.$loading()
          setTimeout(() => {
            loading.close()
            this.$message.error(this.$i18n.t('lang.lab_Online'))
          }, 500)
        }
      },
      // 获取数据
      getData() {
        let loading = this.$loading()
        this.$get(
          `/roomOwner/page?pageNo=${this.pageNo}&pageSize=${this.pageSize}&gardenId=${this.gardenId}&fjType=0&fjName=`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // id查询楼号楼层房间号
      gardenGrids(type, id) {
        if (id === '') return
        this.$get(`/gardenGrids/?type=${this.type}&parentId=${id}&pageNo=1&pageSize=9999`).then(
          res => {
            if (res && res.errCode === 0) {
              if (this.type === 1) {
                this.houses = res.list
              } else if (this.type === 2) {
                this.units = res.list
              } else if (this.type === 3) {
                this.rooms = res.list
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 根据小区选择获取楼号
      selectHouse(id) {
        this.type = 1
        this.form.houseId = ''
        this.form.unitId = ''
        this.form.roomId = ''
        this.houses = []
        this.units = []
        this.rooms = []
        this.gardenGrids(this.type, id)
      },
      // 根据楼号选择获取单元
      selectUnit(id) {
        this.type = 2
        this.form.unitId = ''
        this.form.roomId = ''
        this.units = []
        this.rooms = []
        this.gardenGrids(this.type, id)
      },
      // 根据单元选择获取房间
      selectRoom(id) {
        this.type = 3
        this.rooms = []
        this.form.roomId = ''
        this.gardenGrids(this.type, id)
      },
      // 表格下载
      excelDownloadClick() {
        if (navigator.onLine) {
          // Excel表头
          const tHeader = [
            this.$i18n.t('lang.lab_preHouseholdName'),
            this.$i18n.t('lang.lab_buildingnum'),
            this.$i18n.t('lang.lab_unitnum'),
            this.$i18n.t('lang.lab_roomnum'),
            this.$i18n.t('lang.lab_preHouseholdPhone'),
            this.$i18n.t('lang.lab_preHouseholdID'),
            this.$i18n.t('lang.lab_preHouseholdArea')
          ]
          // 对应table数据的列字段名
          const filterVal = ['name', 'houseName', 'unitName', 'roomName', 'mobile', 'idNo', 'buildArea']
          excelDownload(tHeader, filterVal, this.tableData, this.$i18n.t('lang.lab_originalHouseholdDataManagement'))
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
      // 新增
      add() {
        window.localStorage.setItem('editPreInfoForm', '')
        window.localStorage.setItem('editPreInfoSaveData', '')
        this.$router.push({
          name: 'addPreInfo',
          query: {
            flag: false
          }
        })
      },
      // 编辑
      edit(rowData) {
        window.localStorage.setItem('editPreInfoForm', '')
        window.localStorage.setItem('editPreInfoSaveData', '')
        this.$router.push({
          name: 'editPreInfo',
          query: {
            flag: true,
            object: rowData
          }
        })
      },
      // 查询
      commit() {
        this.pageNo = 1
        this.search()
      },
      // 筛选
      search() {
        let loading = this.$loading()
        this.$get(
          `/roomOwner/page?pageNo=${this.pageNo}&pageSize=${this.pageSize}&gardenId=${this.gardenId}&houseId=${this.form.houseId}&unitId=${this.form.unitId}&roomId=${this.form.roomId}&key=${this.form.key}&id=${this.form.id}&fjName=${this.form.fjName}&${this.form.fjType ? 'fjType=' + this.form.fjType : 'fjType=0'}`
        ).then(
          res => {
            if (res && res.errCode === 0) {
              loading.close()
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 批量删除
      batchDel(id) {
        let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          )
          .then(() => {
            let deleteIds = ''
            if (id) {
              deleteIds = id
            } else {
              deleteIds = this.selectArr.join(',')
            }
            console.log(deleteIds)
            let params = {
              idArr: deleteIds
            }
            this.$delete(`/roomOwner/delByBatch`, params).then(
              res => {
                loading.close()
                console.log(res)
                if (res && res.errCode === 0) {
                  this.$message.success('删除成功')
                  this.commit()
                }
              },
              error => {
                console.log(error)
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 下载模板
      download() {
        if (navigator.onLine) {
          window.open(require('@/config/enum').mould)
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
      // 文件上传数量超过提醒
      outlimit() {
        this.$message.warning(this.$i18n.t('lang.lab_uploadWarning'))
      },
      // 移除附件
      handleRemove(file, fileList) {
        console.log('Remove Success!', file, fileList)
        this.fileList = []
        this.uploadFile.length = 0
      },
      // 文件上传
      handleSuccess(e) {
        console.log('Upload Success!', e)
        this.uploadFile = e.raw
      },
      // 导入业主
      submitUpload() {
        if (this.uploadFile.length < 1) {
          this.$message.warning(this.$i18n.t('lang.lab_pleaseSeletcUploadDoc'))
        } else {
          let formData = new FormData()
          formData.append('excelFile', this.uploadFile)
          let loading = this.$loading()
          this.$postFormData(`/inputRoomOwner/`, formData).then(
            res => {
              loading.close()
              this.$message.success(this.$i18n.t('lang.lab_uploadSuccess'))
              this.commit()
              this.fileList = []
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.search()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.search()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
        let selectArr = []
        val.forEach(element => {
          selectArr.push(element.id)
        })
        this.selectArr = selectArr
        console.log(selectArr)
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      // 展示业主基本信息弹窗
      showEditBasicInfoDialog(row) {
        console.log(row)
        this.basicInfoForm.remark = ''
        this.filesList99 = []
        this.fileList99 = []
        this.rowData = row
        this.basicInfoForm.name = row.name
        this.basicInfoForm.mobile = row.mobile
        this.basicInfoForm.idNo = row.idNo
        this.editBasicInfoDialog = true
      },
      // 手机号码输入限制
      keyMobile() {
        // 仅保留数字
        this.basicInfoForm.mobile = this.basicInfoForm.mobile.replace(/[^\d]/g, '')
      },
      getFile99(e) {
        console.log(e)
        this.fileList99.push(e)
      },
      removeFile99(e) {
        console.log(e)
        let list1 = []
        for (let i = 0; i < this.fileList99.length; i++) {
          if (this.fileList99[i] === e) {} else {
            list1.push(this.fileList99[i])
          }
        }
        this.fileList99 = list1
      },
      // 修改业主基本信息
      editBasicInfo(formName) {
        this.$refs[formName].validate((valid) => {
            if (valid) {
              this.basicInfoForm.url = this.fileList99.join(',')
              console.log(this.basicInfoForm)
              // 没有修改
              if (this.basicInfoForm.name == this.rowData.name && this.basicInfoForm.mobile == this.rowData.mobile && this.basicInfoForm.idNo == this.rowData.idNo) {
                this.editBasicInfoDialog = false
                return false
              }
              // 修改前如果有身份证号，不允许清空身份证
              if (this.rowData.idNo != '' && this.basicInfoForm.idNo == '') {
                this.$message.error('不允许清空身份证，请输入身份证号码')
                return false
              }
              // 修改电话号需要输入备注
              if (this.basicInfoForm.mobile != this.rowData.mobile && this.basicInfoForm.remark == '') {
                this.$message.error('修改业主电话号码，请输入备注，说明更改原因')
                return false
              }
              // 修改姓名或身份证，需备注并上传房证或备案合同、身份证照片
              if ((this.basicInfoForm.name != this.rowData.name || this.basicInfoForm.idNo != this.rowData.idNo) && (this.basicInfoForm.url == '' || this.basicInfoForm.remark == '')) {
                this.$message.error('修改业主姓名或身份证，请输入备注并上传房证或备案合同、身份证照片')
                return false
              }
              let loading = this.$loading()
              let params = {
                gardenId: this.rowData.gardenId,
                roomOwnerId: this.rowData.id,
                oldName: this.rowData.name,
                newName: this.basicInfoForm.name,
                oldMobile: this.rowData.mobile,
                newMobile: this.basicInfoForm.mobile,
                oldIdNo: this.rowData.idNo,
                newIdNo: this.basicInfoForm.idNo,
                remark: this.basicInfoForm.remark,
                photos: this.basicInfoForm.url,
              }
              console.log(params)
              this.$post(`/roomOwnerChangeCheck`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success('修改申请已提交，请等待审批结果')
                    this.editBasicInfoDialog = false
                  }
                },
                error => {
                  loading.close()
                  this.diaIsShow = false
                  if (error == '重复数据') {
                    this.$message.error('您已提交过修改申请，待审核出结果后可再次提交')
                  } else {
                    this.$message.error(error)
                  }
                }
              )
          } else {
            return false
          }
        })
    },
  }
  }
</script>

<style lang='scss'>
</style>